export default __webpack_public_path__ + "static/media/e-commerce-promotion.a2ae897c.png";